export default __webpack_public_path__ + "static/media/serviços1.622b4b78.svg";